import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import PDFConverter from "./pdf/PDFConverter";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    // You can log errorInfo here if needed
  }
  render() {
    if (this.state.hasError) {
      return <div style={{ color: 'red', padding: 24 }}><h2>Something went wrong.</h2><pre>{this.state.error && this.state.error.toString()}</pre></div>;
    }
    return this.props.children;
  }
}

function Home() {
  return (
    <>
      <PDFConverter />
      <div style={{ marginTop: 40, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
        <a
          href="https://play.google.com/store/apps/details?id=com.pdfme.app"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            background: '#000',
            color: '#fff',
            fontWeight: 'bold',
            padding: '10px 20px',
            borderRadius: 8,
            textDecoration: 'none',
            boxShadow: '0 2px 8px #0002',
            fontSize: 16
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512" fill="currentColor">
            <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
          </svg>
          Get it on Google Play
        </a>
        <a
          href="https://hellomydude.gumroad.com/coffee"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            background: '#ffdd00',
            color: '#222',
            fontWeight: 'bold',
            padding: '12px 28px',
            borderRadius: 8,
            textDecoration: 'none',
            boxShadow: '0 2px 8px #0002',
            fontSize: 18
          }}
        >
          ☕ Buy Me a Coffee
        </a>
      </div>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <div style={{ maxWidth: 900, margin: "0 auto", padding: 24 }}>
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            <Link to="/">
              <img src="/icon-512.svg" alt="PDF ME" style={{ height: 64 }} />
            </Link>
          </div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
          <footer style={{ marginTop: 48, textAlign: 'center', fontSize: 14, color: '#fff', borderTop: '1px solid #eee', paddingTop: 16 }}>
            <Link to="/privacy" style={{ color: '#fff', textDecoration: 'none', marginRight: 16 }}>Privacy Policy</Link>
            <Link to="/terms" style={{ color: '#fff', textDecoration: 'none' }}>Terms of Service</Link>
            <div style={{ marginTop: 8 }}>© {new Date().getFullYear()} PDF ME. All rights reserved.</div>
          </footer>
        </div>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
